import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from 'store/hooks';
import { RolesEnum } from 'types/user';

const authRootStateSelector = (state: any) => state.auth;

export const accessTokenSelector = createSelector(
  authRootStateSelector,
  ({ currentUser }) => currentUser?.tokens?.accessToken,
);

export const requestTokenSelector = createSelector(
  authRootStateSelector,
  ({ currentUser }) => currentUser?.tokens?.refreshToken,
);

export const loginInFlightSelector = createSelector(
  authRootStateSelector,
  ({ loading }) => loading,
);

export const loginDetailsSelector = createSelector(
  authRootStateSelector,
  ({ currentUser }) => currentUser,
);

const userRoleSelector = createSelector(
  authRootStateSelector,
  ({ currentUser }) => currentUser?.permissions,
);

const isAdminSelector = createSelector(
  authRootStateSelector,
  ({ currentUser }) =>
    Boolean(
      currentUser?.permissions
        ?.map((p: any) => p.role)
        ?.includes(RolesEnum.SUPER_ADMIN),
    ),
);

type Roles =
  | Array<{
      role: RolesEnum;
      _id: string;
    }>
  | undefined;

export const useUser = () => useAppSelector(loginDetailsSelector);
export const useRoles = () => useAppSelector<Roles>(userRoleSelector);
export const useIsSuperAdmin = () => useAppSelector(isAdminSelector);
